(function() {
    function musicFunc() {
        const musicContainer = document.querySelector('.music-container');
        if (!musicContainer || musicContainer.dataset.musicInitialized === 'true') {
            return;
        }
        musicContainer.dataset.musicInitialized = 'true';

        const playBtn = document.querySelector('#play');
        const prevBtn = document.querySelector('#music-prev');
        const nextBtn = document.querySelector('#music-next');
        const audio = document.querySelector('#audio');
        const progress = document.querySelector('.progress');
        const musicImgUrl = musicContainer.getAttribute('music-image-url');
        const menu = document.querySelector('.pages-menu');
        const songBar = document.getElementById('song-bar');
        const trackNameEl = document.getElementById('current-track-name');
        const cover = document.querySelector('#cover');

        if (!playBtn || !audio) {
            return;
        }

        const bodyStyles = getComputedStyle(document.body);
        const customCursorValue = bodyStyles.getPropertyValue('--custom-cursor').trim();
        if (customCursorValue) {
            document.documentElement.style.cursor = 'url("' + customCursorValue + '"), auto';
        }

        if (menu && menu.getAttribute('align-menu-right') != null) {
            musicContainer.style.left = '-15px';
            musicContainer.style.right = 'auto';
            if (songBar) {
                
                    songBar.style.left = '167px';
                
            }
        } else if (menu) {
            musicContainer.style.left = 'auto';
            musicContainer.style.right = '-15px';
        }

        if (window.innerWidth <= 479 && musicContainer.classList.contains('disable-music')) {
            return;
        }

       const tracks = [
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Penultimate_Boss_Prod._by_gentlebeatz__KOLAK_Exclusive.mp3?v=1775925819", name: "Penultimate Boss - A KOLAK Exclusive (Instrumental) [Prod. Gentle Beatz]" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/DESIGNER.mp3?v=1782431701", name: "Darnell Williams - 'DESIGNER'" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Larry_June_x_Cardo_Type_Beat_-_Pacific_Breeze.mp3?v=1782429468", name: "'Pacific Breeze' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/PANAMERA.mp3?v=1782430312", name: "'Panarama' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Marble_Floors.mp3?v=1782430313", name: "'Marble Floors' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Larry_June_x_Cardo_Type_Beat_-_Sunset_Groove.mp3?v=1782428686", name: "'Sunset Groove' (Prod. Yuho x luka burr)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/OJ_Cuban_Cigars.mp3?v=1782430313", name: "'OJ \u0026 Cuban Cigars' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Champagne_By_The_Ocean.mp3?v=1782430313", name: "'Champagne By The Ocean' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Sunset_Cruise.mp3?v=1782430313", name: "'Sunset Groove' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Tropical_Melodies.mp3?v=1782430312", name: "'Tropical Melodies' (Prod. Yuho)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/DESIGNER_GEAR_feat._Monroe_Flow.mp3?v=1782432260", name: "DESIGNER GEAR (feat. Monroe Flow)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Mortal_Kombat_II_Arcade_Musik__Wasteland_The_Pit_II.mp3?v=1777667842", name: "Mortal Kombat II Arcade Original (Wasteland \/ The Pit II) [Prod. Dan Forden]" },
  { url: "", name: "" },
  { url: "", name: "" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Cardo_-_MK_Unreleased_Instrumental.mp3?v=1782435104", name: "MK (Unreleased Instrumental) [Prod. Cardo Got Wings]" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Larry_June_-_Organic_Tokens_Instrumental.mp3?v=1775928213", name: "Larry June - Orange Tokens (Instrumental) [Prod. Cardo Got Wings]" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Payroll_Giovanni_-_Feel_How_I_Look_Instrumental.mp3?v=1775926871", name: "Payroll Giovanni – Feel How I Look (Instrumental) [Prod. Cardo Got Wings \u0026 DUKEBEATZ]" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/M83_-_Midnight_City_Lyrics.mp3?v=1782429017", name: "M83 - Midnight City" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/ODESZA_-_A_Moment_Apart.mp3?v=1782434124", name: "ODESZA - A Moment Apart" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/RUFUS_DU_SOL_-_Innerbloom.mp3?v=1782434325", name: "RÜFÜS DU SOL - Innerbloom" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Walking_On_A_Dream_by_Empire_Of_The_Sun_HQ_Music.mp3?v=1782434324", name: "Empire Of The Sun - Walking On A Dream" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Pretend.mp3?v=1783052222", name: "Tia Talks - Pretend (Prod. Limitless)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/A_Little_Bit_Darker.mp3?v=1783052222", name: "Tia Talks - A Little Bit Darker (Prod. Limitless)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/FREE_Larry_June_Type_Beat_-_Organic_Views.mp3?v=1782431499", name: "'Organic Views' (Prod. Who On The Track)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Money_Talks_Prod_by_Steeze.mp3?v=1782431593", name: "Money Talks (Prod by Steeze)" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/Tsikuni_-_stoner.mp3?v=1782431489", name: "Tsikuni - Stoner" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/young_nudy_x_pierre_bourne_x_mightymouse_type_beat_get_away.mp3?v=1782432597", name: "young nudy x pierre bourne x mightymouse - get away" },
  { url: "", name: "" },
  { url: "", name: "" },
  { url: "https:\/\/cdn.shopify.com\/s\/files\/1\/0703\/6728\/1196\/files\/STRONGER.mp3?v=1763854017", name: "Kanye West - Stronger (Instrumental)" },
  { url: "", name: "Track 31 - Example Artist" },
  { url: "", name: "Track 32 - Example Artist" },
  { url: "", name: "Track 33 - Example Artist" },
  { url: "", name: "Track 34 - Example Artist" },
  { url: "", name: "Track 35 - Example Artist" },
  { url: "", name: "Track 36 - Example Artist" },
  { url: "", name: "Track 37 - Example Artist" },
  { url: "", name: "Track 38 - Example Artist" },
  { url: "", name: "Track 39 - Example Artist" },
  { url: "", name: "Track 40 - Example Artist" },
  { url: "", name: "Track 41 - Example Artist" },
  { url: "", name: "Track 42 - Example Artist" },
  { url: "", name: "Track 43 - Example Artist" },
  { url: "", name: "Track 44 - Example Artist" },
  { url: "", name: "Track 45 - Example Artist" },
  { url: "", name: "Track 46 - Example Artist" },
  { url: "", name: "Track 47 - Example Artist" },
  { url: "", name: "Track 48 - Example Artist" },
  { url: "", name: "Track 49 - Example Artist" },
  { url: "", name: "Track 50 - Example Artist" },
  { url: "", name: "Track 51 - Example Artist" },
  { url: "", name: "Track 52 - Example Artist" },
  { url: "", name: "Track 53 - Example Artist" },
  { url: "", name: "Track 54 - Example Artist" },
  { url: "", name: "Track 55 - Example Artist" },
  { url: "", name: "Track 56 - Example Artist" },
  { url: "", name: "Track 57 - Example Artist" },
  { url: "", name: "Track 58 - Example Artist" },
  { url: "", name: "Track 59 - Example Artist" },
  { url: "", name: "Track 60 - Example Artist" },
  { url: "", name: "Track 61 - Example Artist" },
  { url: "", name: "Track 62 - Example Artist" },
  { url: "", name: "Track 63 - Example Artist" },
  { url: "", name: "Track 64 - Example Artist" },
  { url: "", name: "Track 65 - Example Artist" },
  { url: "", name: "Track 66 - Example Artist" },
  { url: "", name: "Track 67 - Example Artist" },
  { url: "", name: "Track 68 - Example Artist" },
  { url: "", name: "Track 69 - Example Artist" },
  { url: "", name: "Track 70 - Example Artist" },
  { url: "", name: "Track 71 - Example Artist" },
  { url: "", name: "Track 72 - Example Artist" },
  { url: "", name: "Track 73 - Example Artist" },
  { url: "", name: "Track 74 - Example Artist" },
  { url: "", name: "Track 75 - Example Artist" },
  { url: "", name: "Track 76 - Example Artist" },
  { url: "", name: "Track 77 - Example Artist" },
  { url: "", name: "Track 78 - Example Artist" },
  { url: "", name: "Track 79 - Example Artist" },
  { url: "", name: "Track 80 - Example Artist" },
  { url: "", name: "Track 81 - Example Artist" },
  { url: "", name: "Track 82 - Example Artist" },
  { url: "", name: "Track 83 - Example Artist" },
  { url: "", name: "Track 84 - Example Artist" },
  { url: "", name: "Track 85 - Example Artist" },
  { url: "", name: "Track 86 - Example Artist" },
  { url: "", name: "Track 87 - Example Artist" },
  { url: "", name: "Track 88 - Example Artist" },
  { url: "", name: "Track 89 - Example Artist" },
  { url: "", name: "Track 90 - Example Artist" },
  { url: "", name: "Track 91 - Example Artist" },
  { url: "", name: "Track 92 - Example Artist" },
  { url: "", name: "Track 93 - Example Artist" },
  { url: "", name: "Track 94 - Example Artist" },
  { url: "", name: "Track 95 - Example Artist" },
  { url: "", name: "Track 96 - Example Artist" },
  { url: "", name: "Track 97 - Example Artist" },
  { url: "", name: "Track 98 - Example Artist" },
  { url: "", name: "Track 99 - Example Artist" },
  { url: "", name: "Track 100 - Example Artist" }
].filter(track => track.url && String(track.url).trim() !== '');

        if (!tracks.length) {
            return;
        }

        function getStorage(key, fallback) {
            try {
                const value = localStorage.getItem(key);
                return value === null ? fallback : value;
            } catch (error) {
                return fallback;
            }
        }

        function setStorage(key, value) {
            try {
                localStorage.setItem(key, value);
            } catch (error) {}
        }

        let currentSongIndex = parseInt(getStorage('pjSongQueue', '0'), 10);
        if (Number.isNaN(currentSongIndex) || currentSongIndex < 0 || currentSongIndex >= tracks.length) {
            currentSongIndex = 0;
        }

        function setPlayIcon(isPlaying) {
            const icon = playBtn.querySelector('i.fas');
            if (!icon) return;
            icon.classList.toggle('fa-play', !isPlaying);
            icon.classList.toggle('fa-pause', isPlaying);
        }

        let pendingSeekTime = 0;

        function applyPendingSeek() {
            if (!pendingSeekTime || !Number.isFinite(audio.duration) || audio.duration <= 0) {
                return;
            }

            try {
                audio.currentTime = Math.min(pendingSeekTime, Math.max(audio.duration - 0.1, 0));
            } catch (error) {
                // Some browsers reject seeks until the audio has enough metadata.
            }

            pendingSeekTime = 0;
        }

        function loadSong(resetTime) {
            const track = tracks[currentSongIndex];
            if (!track) return;

            pendingSeekTime = 0;
            if (!resetTime) {
                const savedTime = parseFloat(getStorage('audioTime', '0'));
                if (!Number.isNaN(savedTime) && savedTime > 0) {
                    pendingSeekTime = savedTime;
                }
            }

            audio.src = track.url;
            audio.load();

            if (trackNameEl) {
                trackNameEl.textContent = track.name || 'Unknown Track';
            }

            if (musicImgUrl && cover) {
                cover.src = musicImgUrl;
            }

            if (resetTime) {
                try {
                    audio.currentTime = 0;
                } catch (error) {}
            } else {
                applyPendingSeek();
            }
        }

        function safePlay() {
            musicContainer.classList.add('play');
            setPlayIcon(true);
            setStorage('audioIsPaused', 'false');
            audio.muted = false;

            const playPromise = audio.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function() {
                    musicContainer.classList.remove('play');
                    setPlayIcon(false);
                });
            }
        }

        function pauseSong() {
            musicContainer.classList.remove('play');
            setPlayIcon(false);
            setStorage('audioIsPaused', 'true');
            audio.pause();
        }

        function goToSong(direction) {
            currentSongIndex = (currentSongIndex + direction + tracks.length) % tracks.length;
            setStorage('pjSongQueue', currentSongIndex);
            loadSong(true);
            safePlay();
        }

        function nextSong() {
            goToSong(1);
        }

        function previousSong() {
            goToSong(-1);
        }

        function updateProgress() {
            if (!progress || !audio.duration || Number.isNaN(audio.duration)) {
                return;
            }
            const progressPercent = (audio.currentTime / audio.duration) * 100;
            progress.style.width = progressPercent + '%';
        }

        if (getStorage('audioIsPaused', 'true') === 'false') {
            musicContainer.classList.add('play');
            setPlayIcon(true);
        } else {
            setPlayIcon(false);
        }

        playBtn.addEventListener('click', function(event) {
            event.preventDefault();
            if (musicContainer.classList.contains('play')) {
                pauseSong();
            } else {
                safePlay();
            }
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', function(event) {
                event.preventDefault();
                previousSong();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function(event) {
                event.preventDefault();
                nextSong();
            });
        }

        audio.addEventListener('loadedmetadata', applyPendingSeek);
        audio.addEventListener('timeupdate', updateProgress);
        audio.addEventListener('ended', nextSong);

        loadSong(false);

        setInterval(function() {
            if (!audio.paused) {
                setStorage('audioTime', audio.currentTime);
            }
        }, 500);

        function onUserInteraction() {
            if (getStorage('audioIsPaused', 'true') === 'false' && audio.paused) {
                safePlay();
            }
            removeInteractionListeners();
        }

        function removeInteractionListeners() {
            document.removeEventListener('click', onUserInteraction);
            document.removeEventListener('touchstart', onUserInteraction);
            document.removeEventListener('keydown', onUserInteraction);
        }

        document.addEventListener('click', onUserInteraction);
        document.addEventListener('touchstart', onUserInteraction);
        document.addEventListener('keydown', onUserInteraction);

        if (cover) {
            cover.addEventListener('click', nextSong);
        }

        if (songBar) {
            let hideTimeout;

            function showSongBar() {
                clearTimeout(hideTimeout);
                songBar.style.visibility = 'visible';
                songBar.classList.add('visible');
            }

            function hideSongBar() {
                hideTimeout = setTimeout(function() {
                    songBar.classList.remove('visible');
                    setTimeout(function() {
                        songBar.style.visibility = 'hidden';
                    }, 300);
                }, 2000);
            }

            const showSongBarSetting = true;
            const alwaysShowSongBarSetting = false;

            if (alwaysShowSongBarSetting) {
                songBar.style.display = 'flex';
                songBar.style.visibility = 'visible';
                songBar.classList.add('visible');
            } else if (showSongBarSetting) {
                [cover, playBtn, prevBtn, nextBtn].forEach(function(control) {
                    if (!control) return;
                    control.addEventListener('mouseenter', showSongBar);
                    control.addEventListener('mouseleave', hideSongBar);
                    control.addEventListener('focus', showSongBar);
                    control.addEventListener('blur', hideSongBar);
                });
            } else {
                songBar.style.display = 'none';
            }

            const centerSongBarSetting = true;
            if (centerSongBarSetting) {
                songBar.style.left = '50%';
                songBar.style.transform = 'translateX(-50%)';
            }
        }
    }

    musicFunc();

    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function() {
            document.querySelectorAll('.music-container').forEach(function(container) {
                container.dataset.musicInitialized = 'false';
            });
            musicFunc();
        });
    }
})();
